/**
 * Inline quick add: toggle panel, PC grid picker, sync native <select>, close / outside click / Esc.
 */

const PC_MQ = '(min-width: 990px)';

function isPc() {
  return typeof window.matchMedia === 'function' && window.matchMedia(PC_MQ).matches;
}

function closePanel(panel) {
  if (!panel || panel.hasAttribute('hidden')) return;
  panel.setAttribute('hidden', '');
  const root = panel.closest('.card-quick-add-inline');
  root?.querySelector('[data-card-quick-add-toggle]')?.setAttribute('aria-expanded', 'false');
}

function updateHeading(root, pill) {
  const valueEl = root.querySelector('[data-variant-heading-value]');
  if (!valueEl || !pill) return;
  const single = root.dataset.headingSingleOption === 'true';
  if (single) {
    valueEl.textContent = pill.dataset.option1Value || pill.textContent.trim();
  } else {
    valueEl.textContent = pill.dataset.variantTitle || pill.textContent.trim();
  }
}

function syncPillsFromSelect(root) {
  const select = root.querySelector('.card-quick-add-inline__variant-select');
  const pills = root.querySelectorAll('.card-quick-add-inline__variant-pill');
  if (!select || !pills.length) return;
  const id = select.value;
  pills.forEach((p) => {
    const on = p.dataset.variantId === id;
    p.classList.toggle('is-selected', on);
    p.setAttribute('aria-selected', on ? 'true' : 'false');
    if (on) updateHeading(root, p);
  });
}

function onPillClick(root, pill) {
  if (pill.disabled) return;
  const select = root.querySelector('.card-quick-add-inline__variant-select');
  if (!select) return;
  select.value = pill.dataset.variantId;
  select.dispatchEvent(new Event('change', { bubbles: true }));
  root.querySelectorAll('.card-quick-add-inline__variant-pill').forEach((p) => {
    const on = p === pill;
    p.classList.toggle('is-selected', on);
    p.setAttribute('aria-selected', on ? 'true' : 'false');
  });
  updateHeading(root, pill);
}

document.addEventListener('click', (e) => {
  const closeBtn = e.target.closest('[data-card-quick-add-close]');
  if (closeBtn) {
    e.preventDefault();
    e.stopPropagation();
    closePanel(closeBtn.closest('.card-quick-add-inline__panel'));
    return;
  }

  const pill = e.target.closest('.card-quick-add-inline__variant-pill');
  if (pill && isPc()) {
    e.preventDefault();
    const root = pill.closest('.card-quick-add-inline');
    if (root) onPillClick(root, pill);
    return;
  }

  const toggleBtn = e.target.closest('[data-card-quick-add-toggle]');
  if (toggleBtn) {
    e.preventDefault();
    const root = toggleBtn.closest('.card-quick-add-inline');
    const panel = root?.querySelector('.card-quick-add-inline__panel');
    if (!root || !panel) return;

    const opening = panel.hasAttribute('hidden');
    if (opening) {
      panel.removeAttribute('hidden');
      toggleBtn.setAttribute('aria-expanded', 'true');
      syncPillsFromSelect(root);
      if (isPc()) {
        root.querySelector('.card-quick-add-inline__picker-close')?.focus();
      } else {
        root.querySelector('.card-quick-add-inline__variant-select')?.focus();
      }
    } else {
      closePanel(panel);
    }
    return;
  }

  document.querySelectorAll('.card-quick-add-inline').forEach((root) => {
    if (root.contains(e.target)) return;
    closePanel(root.querySelector('.card-quick-add-inline__panel'));
  });
});

document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  document.querySelectorAll('.card-quick-add-inline__panel:not([hidden])').forEach((panel) => {
    closePanel(panel);
  });
});

document.addEventListener('change', (e) => {
  const select = e.target.closest('.card-quick-add-inline__variant-select');
  if (!select || isPc()) return;
  const root = select.closest('.card-quick-add-inline');
  if (root) syncPillsFromSelect(root);
});
